<template>
<div>
    <!-- Header -->
    <base-header class="pb-6 pb-4 pt-5 pt-md-6 text-center">
      <!-- <h2 class="display-4">DASHBOARD PERAKU</h2> -->
    </base-header>
&nbsp;
    <b-container fluid class="">
        <b-row class="justify-content-center">
            <b-col lg="12">
                <card header-classes="bg-transparent">
                    <b-row class="my-1">
                    <b-card-header class="border-0">
                        <h3 class="mb-0">CARIAN PENGGUNA</h3>
                    </b-card-header>
                    </b-row>
                    <b-row class="my-1">
                        <b-col sm="3">
                            <label>NAMA</label>
                        </b-col>
                        <b-col sm="5">
                            <b-form-input v-model="form.CONm"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="my-1">
                        <b-col sm="3">
                            <label>NO KAD PENGENALAN</label>
                        </b-col>
                        <b-col sm="5">
                            <b-form-input v-model="form.noKP"></b-form-input>
                        </b-col>
                        <b-button variant="default" @click="carian">Carian Pengguna</b-button>
                    </b-row>
                </card>
            </b-col>
        </b-row>
    </b-container>
    <br /><br /><br /><br />
    <b-container fluid class="mt--6">

        <b-card no-body>
            <b-card-header class="border-0">
                <h3 class="mb-0">SENARAI PENGGUNA</h3>
            </b-card-header>
            <el-table class="table-responsive table" header-row-class-name="thead-light" :header-cell-style="{background:'#f6f9fc',color:'#8898aa'}" :data="pengguna" style="width: 100%">
                <el-table-column label="#" type="index" :index="indexMethod" width="100px">
        </el-table-column>

                <el-table-column label="No. KP" prop="NoKP" min-width="200px">
                </el-table-column>
                <el-table-column label="Nama" prop="Nama" min-width="300px">
                </el-table-column>
                <el-table-column label="Peranan" prop="roleDetails" min-width="150px">
                </el-table-column>

                <el-table-column label="Status" min-width="150px">
                    <template v-slot="{ row }">
                        <b-badge pill variant="info" style="font-size: 0.8125rem" class="badge-sm" v-if="row.StatusAktif == 1">AKTIF</b-badge>
                        <b-badge pill variant="warning" style="font-size: 0.8125rem" class="badge-sm" v-if="row.StatusAktif == 0">TIDAK AKTIF</b-badge>
                    </template>
                </el-table-column>

                <el-table-column label="Tindakan" min-width="150px" align="center">
                    <template slot="header">
                                        <div style="width: 100%; text-align: center">
                                            <base-button v-if="true" size="sm" icon type="success" class="mb-2" style="background-color: #28a745; color: white; font-size: 0.8125rem" @click="addRow()">
                                                <span class="btn-inner--icon"><i class="fas fa-plus-circle"></i></span>
                                                <span class="btn-inner--text">Tambah</span>
                                            </base-button>
                                        </div>
                                    </template>
                    <template v-slot="{ row }">
                        <div style="width:100%;text-align:center">
                            <base-button v-if="true" size="sm" icon type="primary" class="mb-2" @click="showVal(row)">
                                <span class="btn-inner--icon"><i class="ni ni-single-02"></i></span>
                                <span class="btn-inner--text">Edit</span>
                            </base-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <b-card-footer class="py-4 d-flex justify-content-end">
            <el-pagination center background layout="prev, pager, next" :total="ClientPaging.totalRow" :page-size="ClientPaging.totalRowPerPaging" @current-change="pageChanged">
            </el-pagination>
        </b-card-footer>
        </b-card>
    </b-container>

    <!--Form modal-->
    <modal :show.sync="modals.form" size="lg"  body-classes="p-0">
        <template slot="header">
            <h3 class="mb-0">Kemaskini Pengguna</h3>
        </template>

        <template slot="default">
            <kemaskinipengguna :pengguna="penggunarow" @batal="batal" @refreshPaging="refreshPaging"></kemaskinipengguna>
        </template>

        <template slot="footer"> &nbsp; </template>
    </modal>
    <modal :show.sync="modals.addForm" size="xl"  body-classes="p-0">
        <template slot="header">
            <h3 class="mb-0">Kemaskini Pengguna</h3>
        </template>

        <template slot="default">
            <tambahpengguna  @batal="batal" @refreshPaging="refreshPaging"></tambahpengguna>
        </template>

        <template slot="footer"> &nbsp; </template>
    </modal>
</div>
</template>

<script>

import BaseButton from "@/components/BaseButton.vue";
import PenggunaService from "@/services/PenggunaService.js";
import kemaskinipengguna from "@/views/selenggaraPengguna/kemaskinipengguna.vue";
import tambahpengguna from "@/views/selenggaraPengguna/tambahPengguna.vue";
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Table,
    TableColumn,
    Pagination
} from 'element-ui';
export default {
    name: "light-table",

    components: {
        BaseButton,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Pagination.name]: Pagination,
        kemaskinipengguna,
        tambahpengguna,
    },
    data() {
        return {
            modals: {
                form: false,
                addForm: false,
            },
            form: {},
            currentPage: 1,
            ClientPaging: {
                pagingType: 2,
                totalRow: 0,
                totalRowPerPaging: 0,
                totalPage: 0,
                memTableName: null,
                lastPage: 0,
            },
            pengguna: [],
            penggunarow: [],
        }
    },
    methods: {
        pageChanged(val) {
            this.currentPage = val;
            this.queryPageData(val);
        },
        showVal(row) {
            this.modals.form = true;
            this.penggunarow = row;
        },
        indexMethod(index) {
            return (
                index + 1 + (this.currentPage - 1) * this.ClientPaging.totalRowPerPaging
            );
        },
        addRow() {
            this.modals.addForm = true;
        },
        batal() {
            this.modals.addForm = false;
            this.modals.form = false;
        },

        queryPageData(currentPage) {
            const search = this.form
            search['currentPage'] = currentPage

            PenggunaService.getPenggunaData(search)
                .then(resp => {
                    this.pengguna = resp.data;
                })

            console.info("this.pengguna", this.pengguna);
        },
        refreshPaging() {

            this.queryPageData(currentPage)
        },
        carian() {

            const search = this.form
            search['currentPage'] = 1
            PenggunaService.getPenggunaInfo(search)
                .then(resp => {
                    // this.pemanggil = resp.data;
                    this.ClientPaging = resp.data;
                })
                .then(() => {
                    this.queryPageData(1);
                });

        },
    },
    created() {

        let search = {
            currentPage: 1,
        };
        PenggunaService.getPenggunaInfo(search)
            .then(resp => {
                // this.pemanggil = resp.data;
                this.ClientPaging = resp.data;
            })
            .then(() => {
                this.queryPageData(1);
            });

    }
}
</script>
